import { Component, Input, Output, EventEmitter, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { CustomFormFieldSubmission } from '@core/objects/form';

@Component({
    selector: 'form-field-view-email-text-v1',
    templateUrl: './view-email-text-v1.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewEmailTextV1FieldComponent implements OnInit{
    @Input() fieldSubmission: CustomFormFieldSubmission;


    ngOnInit(): void {
    }


}
